module.exports = __webpack_public_path__ + "1791188489487/images/owl.video.play.4a37f80.png";